
const cache = new Map();

/**
 * Headers Laravel expects for a JSON response, mirroring the axios defaults set
 * in bootstrap.js so these requests behave identically.
 *
 * @returns {Record<string, string>}
 */
function jsonHeaders() {
  const csrfToken = window.axios?.defaults?.headers?.common?.['X-CSRF-TOKEN'];

  return {
    Accept: 'application/json',
    'X-Requested-With': 'XMLHttpRequest',
    ...(csrfToken && { 'X-CSRF-TOKEN': csrfToken }),
  };
}

/**
 * Fetch a URL at most once per page load.
 *
 * @param {string} url
 * @param {{ force?: boolean }} [options]
 * @returns {Promise<any>}
 */
export function fetchReferenceData(url, options = {}) {
  if (!url) {
    return Promise.reject(new Error('fetchReferenceData requires a url'));
  }

  if (options.force) {
    cache.delete(url);
  }

  if (!cache.has(url)) {
    const request = fetch(url, {
      method: 'GET',
      headers: jsonHeaders(),
      credentials: 'same-origin',
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`Request to ${url} failed with status ${response.status}`);
        }

        return response.json();
      })
      .catch((error) => {
        cache.delete(url);
        throw error;
      });

    cache.set(url, request);
  }

  return cache.get(url);
}

/**
 * Drop one URL, or the whole cache when called with no argument.
 *
 * @param {string} [url]
 * @returns {void}
 */
export function clearReferenceData(url) {
  if (url) {
    cache.delete(url);

    return;
  }

  cache.clear();
}

export function useReferenceData() {
  return { fetchReferenceData, clearReferenceData };
}
